import { ComponentProps } from 'react';
import { CopyIcon } from 'lucide-react';
import { motion } from 'motion/react';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

const MotionCopyIcon = motion.create(CopyIcon);

export function Copy(props: ComponentProps<typeof MotionCopyIcon>) {
  return (
    <MotionCopyIcon
      {...props}
      className={cn(css.copy, props.className)}
      variants={{
        from: {
          '--animated-copy-progress': 0,
        },
        to: {
          '--animated-copy-progress': 1,
        },
      }}
      aria-hidden
    />
  );
}
